window.applySubscribeColors = function() {
  const subscribeWidgets = document.querySelectorAll('.js--widget_subscribe_category');

  if (subscribeWidgets) {
    subscribeWidgets.forEach((item) => {
      item.style.setProperty('--subscribe-color', item.getAttribute('data-color'));
    });
  }
}

document.addEventListener('DOMContentLoaded', window.applySubscribeColors);
